import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const KKBSkidataNeo = () => (
  <ArticleWrapper articleId="kkb_skidata_neo">
    <div className="prose prose-invert mx-auto p-6">
      <h1>KKB Skidata Neo</h1>
      {/* Add your KKB Skidata Neo article content here */}
      <p>This is a placeholder article for the KKB Skidata Neo keycap set. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default KKBSkidataNeo;
